import { useGetRolesQuery } from '@/store/services/users';
import { MenuItem, Select } from '@mui/material';
import TextField from '@mui/material/TextField';
import { Controller, useFormContext } from 'react-hook-form';

function BasicInfoTab() {
	const methods = useFormContext();
	const { control, formState } = methods;
	const { errors } = formState;

	const { data: roles = [] } = useGetRolesQuery({});

	return (
		<div>
			<Controller
				name="name"
				control={control}
				render={({ field }) => (
					<TextField
						{...field}
						className="mt-2 mb-4"
						required
						label="Name"
						autoFocus
						id="name"
						variant="outlined"
						fullWidth
						error={!!errors.name}
						helperText={errors?.name?.message as string}
					/>
				)}
			/>
			<Controller
				name="email"
				control={control}
				render={({ field }) => (
					<TextField
						{...field}
						className="mt-2 mb-4"
						required
						label="Email"
						autoFocus
						id="email"
						variant="outlined"
						fullWidth
						type="email"
						error={!!errors.email}
						helperText={errors?.email?.message as string}
					/>
				)}
			/>
			<div className="w-full mb-2">
				<Controller
					name="role_id"
					control={control}
					render={({ field }) => (
						<Select
							{...field}
							fullWidth
							displayEmpty
							sx={{
								'& .MuiOutlinedInput-root': {
									width: '100% !important'
								}
							}}
							value={field.value || ''}
							onChange={(event) => field.onChange(event.target.value)}
						>
							<MenuItem
								value=""
								disabled
							>
								Select Role
							</MenuItem>
							{roles?.data?.map((role) => (
								<MenuItem
									key={role.id}
									value={role.id}
								>
									{role.name}
								</MenuItem>
							))}
						</Select>
					)}
				/>
			</div>
		</div>
	);
}

export default BasicInfoTab;
